import { FormControl } from "@material-ui/core";
import { styled } from "@material-ui/styles";

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  ...theme.typography.customInput
}));
